import React from 'react';

const Blog = () => {
    return (
        <div className='container'>
            <h1>Interview Questions</h1> <hr></hr>
            <div>
<h2>Q1: Difference between Authorization and Authentication?</h2>
<h3>Authentication:</h3> <h4> Authentication verifies the user. It works on password, pins, biometric and other information that is provided by the user. Authentication is the good identity and access management process. It is visible and user can change it anytime.
</h4>
<h3>Authorization:</h3> <h4> Authorization refers resources a user can access. It works on setting that are maintaining by the organizations. Authorization always takes place after authentication. User can't change it and it is not visible.</h4>

            </div>
            <div>
                <h2> Q2:Why are You using Firebase?What other option do you have to implement authenticattion?</h2>
                <h4>Firebase Analytics gives you undeniable insight into user behavior. You can use this knowledge to make informed decisions about how to market your app better and to reach out to the audiences that you want to target.Usually, authentication by a server entails the use of a user name and password. Other ways to authenticate can be through cards, retina scans, voice recognition, and fingerprints.</h4>
            </div>
            <div>
<h2>Q3: What other services does firebase provide other than authentication?</h2>
<h4>There are many services which Firebase provides, Most useful of them are: Cloud FireStore, Cloud Functions, Authentication, Hosting, Cloud Storage, Google Analytics, Predictions, Cloud Messaging and etc</h4>
            </div>
        </div>
    );
};

export default Blog;